import { createApp } from 'vue'
import DiscountCalculator from './DiscountCalculator.vue'
import './assets/global.css'

createApp(DiscountCalculator).mount('#discount')
